<div class="customise-review">
	<!--  STEP HEADER  -->

	<cng-step-header [current_step_key]="current_step_key" [location]="'engage_configure'" (jump)="jumpTo($event)"></cng-step-header>

	<!--  END STEP HEADER  -->

	<!--  CONTAINER  -->

	<div class="container">
		<!--  HEADING  -->

		<div class="heading">
			<ui-concierge
				data-element-view="concierge__engage_configure_customise_review_step__[Protect your investment with our product range]"
			>
				<div class="hidden-xxs hidden-xs">
					<h1>Protect your investment with our product range</h1>

					<p>You can select one or more of the products below.</p>

					<p class="margin-top-0">
						<ng-container *ngIf="has_videos; else has_no_videos">
							Click on a product to find out more, watch a video about the product and add it to your deal.
						</ng-container>
						<ng-template #has_no_videos>Click on a product to find out more and add it to your deal.</ng-template>
					</p>
				</div>

				<div class="hidden-sm hidden-md hidden-lg hidden-xl">
					<h1>
						<ng-container *ngIf="has_videos; else has_no_videos">
							Click on a product to find out more, watch a video about the product and add it to your deal.
						</ng-container>
						<ng-template #has_no_videos>Click on a product to find out more and add it to your deal.</ng-template>
					</h1>
				</div>
			</ui-concierge>
		</div>

		<!--  END HEADING  -->

		<!--  VEHICLE & ADDONS  -->

		<div class="customise-review-section vehicle-and-addons">
			<div class="customise-review-section-inner">
				<!--  HEADER  -->

				<div class="row items-header">
					<div class="col-xxs-30 col-sm-16 col-header-title">
						New Vehicle
						<span *ngIf="addons.length > 0">&amp; Add-Ons</span>
					</div>
					<div *ngIf="show_addon_finance" class="col-sm-7 hidden-xxs hidden-xs align-right">Monthly Cost</div>
					<div class="col-sm-7 hidden-xxs hidden-xs align-right" [ngClass]="{ 'col-sm-14': !show_addon_finance }">Cash Price</div>
				</div>

				<!--  END HEADER  -->

				<!--  ITEMS  -->

				<ul class="items">
					<!--  VEHICLE  -->

					<li class="row">
						<div class="col-xxs-23 col-sm-12 col-item-title">
							<img
								src="https://0"
								class="manufacturer-logo"
								[attr.src]="vehicle.brand_logo_url"
								[attr.alt]="vehicle.make + ' ' + vehicle.model"
								onerror="this.src = '/assets/icons/icon_car.svg'; this.style.opacity = 0.3;"
							/>
							<div class="item-title">
								<div class="item-title-text">{{ vehicle.make }} {{ vehicle.model }}</div>
								<div class="item-subtitle-text">{{ vehicle.edition }}</div>
							</div>
						</div>
						<div class="col-xxs-7 col-sm-4 col-brand">
							<span *ngIf="vehicle.registration" class="number-plate">{{ vehicle.registration }}</span>
						</div>
						<div *ngIf="show_addon_finance" class="col-xxs-15 col-sm-7 col-finance text-hl">
							<span>
								{{ vehicle_per_month | money }}
								<small>P/M</small>
							</span>
						</div>
						<div *ngIf="show_addon_finance" class="col-xxs-4 visible-xxs visible-xs align-center col-or">
							<span>or</span>
						</div>
						<div class="col-xxs-11 col-sm-7 col-cash text-hl" [ngClass]="{ 'col-xxs-30 col-sm-14': !show_addon_finance }">
							{{ vehicle.price | money }}
							<small *ngIf="vehicle.add_vat">+ VAT</small>
						</div>
					</li>

					<!--  END VEHICLE  -->

					<!--  ADDON LOOP  -->

					<li
						*ngFor="let addon of addons; let i = index"
						class="row checkable"
						[attr.data-element-click]="
							'addon_row__engage_configure_customise_review__[' +
							addon.description +
							'][Options: ' +
							addon.selected_options.length +
							']'
						"
						(click)="setEditAddon(addon, i)"
						[ngClass]="{ checked: addon.selected_options.length > 0 }"
					>
						<div class="col-xxs-23 col-sm-12 col-item-title">
							<i class="icon-tick checkbox" [class.checked]="addon.selected_options.length > 0"></i>
							<div class="item-title">
								<div class="item-title-text">
									{{ addon.description }}
									<i
										class="icon-info text-hl"
										[tooltip]="'Info &amp; Options'"
										[placement]="'right'"
										[attr.data-element-click]="
											'addon_row__engage_configure_customise_review__[' +
											addon.description +
											'][Options: ' +
											addon.selected_options.length +
											']'
										"
									></i>
								</div>
								<div class="item-subtitle-text" [ngSwitch]="addon.selected_options.length">
									<span *ngSwitchCase="1">
										{{ addon.selected_options[0].description }}
										<span *ngIf="getRemainingAddons(addon)">({{ getRemainingAddons(addon) }} more available)</span>
									</span>
									<span *ngSwitchCase="0">{{ addon.options.length | pluralise : 'option' : '+s' }} available</span>
									<span *ngSwitchDefault>
										{{ addon.selected_options.length | pluralise : 'option' : '+s' }} selected
										<span *ngIf="getRemainingAddons(addon)">({{ getRemainingAddons(addon) }} more available)</span>
									</span>
								</div>
							</div>
						</div>
						<div class="col-xxs-7 col-sm-4 col-brand">
							<img
								*ngIf="addon.provider_logo !== null"
								src="https://0"
								class="addon-logo"
								[attr.src]="buildAddonLogoUrl(addon.provider_logo)"
								[attr.alt]="addon.provider_name"
							/>
						</div>
						<div *ngIf="show_addon_finance" class="col-xxs-15 col-sm-7 col-finance text-hl">
							<span *ngIf="addon.financeable">
								+ {{ addon.total_per_month | money }}
								<small>P/M</small>
							</span>
							<span
								*ngIf="!addon.financeable"
								[tooltip]="'Finance is not available on this product. Cash amount will be added to your deposit.'"
								[placement]="'top'"
							>
								<small>N/A</small>
							</span>
						</div>
						<div *ngIf="show_addon_finance" class="col-xxs-4 visible-xxs visible-xs align-center col-or">
							<span>or</span>
						</div>
						<div class="col-xxs-11 col-sm-7 col-cash text-hl" [ngClass]="{ 'col-xxs-30 col-sm-14': !show_addon_finance }">
							+ {{ addon.total_cash | money }}
							<small *ngIf="vehicle.add_vat && addon.has_vq_option && addon.total_cash !== 0">+ VAT</small>
						</div>
					</li>

					<!--  END ADDON LOOP  -->

					<!--  SUBTOTAL  -->

					<li class="row sub-total">
						<div class="col-xxs-30 col-sm-16 col-item-title">
							<div class="item-title">Sub Total:</div>
						</div>
						<div *ngIf="show_addon_finance" class="col-xxs-13 col-sm-7 col-finance">
							{{ vehicle_per_month + addons_subtotal.per_month | money }}
							<small>P/M</small>
						</div>
						<div *ngIf="show_addon_finance" class="col-xxs-4 visible-xxs visible-xs align-center col-or">
							<span>or</span>
						</div>
						<div class="col-xxs-13 col-sm-7 col-cash" [ngClass]="{ 'col-xxs-30 col-sm-14': !show_addon_finance }">
							{{ vehicle.price + addons_subtotal.cash | money }}
							<small *ngIf="vehicle.add_vat">+ VAT</small>
						</div>
					</li>

					<!--  END SUBTOTAL  -->
				</ul>

				<!--  END ITEMS  -->
			</div>
		</div>

		<!--  END VEHICLE & ADDONS  -->

		<!--  PART EXCHANGE  -->

		<div *ngIf="pex_enabled" class="customise-review-section part-exchange">
			<div class="customise-review-section-inner">
				<!--  HEADER  -->

				<div class="row items-header">
					<div class="col-xxs-30 col-sm-16 col-header-title">
						<span>Part Exchange</span>
						<span *ngIf="part_exchanges === null || part_exchanges.length < 1" class="icons">
							<ui-icon-button
								[is_large]="true"
								[icon]="'add'"
								[tooltip]="'Add Part Exchange'"
								data-element-click="add_icon__engage_configure_customise_review[part_exchange]__[Add Part Exchange]"
								(click)="onAddPartExchange()"
							></ui-icon-button>
						</span>

						<span *ngIf="!(part_exchanges === null || part_exchanges.length < 1)" class="icons">
							<ui-icon-button
								[is_large]="true"
								[icon]="'pencil'"
								[tooltip]="'Edit Part Exchange'"
								data-element-click="pencil_icon__engage_configure_customise_review[part_exchange]__[Edit Part Exchange]"
								(click)="onEditPartExchange()"
							></ui-icon-button>
							<ui-icon-button
								[is_large]="true"
								[icon]="'bin'"
								[use_branding]="true"
								[type]="'negative'"
								[tooltip]="'Remove Part Exchange'"
								data-element-click="bin_icon__engage_configure_customise_review[part_exchange]__[Remove Part Exchange]"
								(click)="onRemovePex()"
							></ui-icon-button>
						</span>
					</div>
					<div
						*ngIf="show_addon_finance && part_exchanges !== null && part_exchanges.length > 0"
						class="col-sm-7 hidden-xxs hidden-xs align-right"
					>
						Monthly Cost
					</div>
					<div
						*ngIf="part_exchanges !== null && part_exchanges.length > 0"
						class="col-sm-7 hidden-xxs hidden-xs align-right"
						[ngClass]="{ 'col-sm-14': !show_addon_finance }"
					>
						Amount
					</div>
				</div>

				<!--  END HEADER  -->

				<!--  ITEMS  -->

				<ul class="items">
					<!--  NO PART EXCHANGE  -->

					<li *ngIf="part_exchanges === null || part_exchanges.length < 1" class="row">
						<div class="col-xxs-30 col-no-items">No part exchange</div>
					</li>

					<!--  END NO PART EXCHANGE  -->

					<!--  PART EXCHANGES LOOP  -->

					<ng-template ngFor [ngForOf]="part_exchanges" let-p>
						<!--  PART EXCHANGE VEHICLE  -->

						<li class="row">
							<div class="col-xxs-23 col-sm-12 col-item-title">
								<img
									src="https://0"
									class="manufacturer-logo"
									[attr.src]="buildBrandLogoUrl(p.vehicle.make)"
									[attr.alt]="p.vehicle.make + ' ' + p.vehicle.model"
									onerror="this.src = '/assets/icons/icon_car.svg'; this.style.opacity = 0.3;"
								/>
								<div class="item-title">
									<div class="item-title-text">{{ p.vehicle.make }} {{ p.vehicle.model }}</div>
									<div class="item-subtitle-text">{{ p.vehicle.edition }}</div>
								</div>
							</div>
							<div class="col-xxs-7 col-sm-4 col-brand">
								<span *ngIf="p.registration !== null" class="number-plate">{{ p.registration }}</span>
							</div>
							<div *ngIf="show_addon_finance" class="col-xxs-15 col-sm-7 col-finance text-hl">
								<span *ngIf="p.vehicle.max_value !== null">
									- {{ pex_allowance_pm || 0 | money }}
									<small>P/M</small>
								</span>
							</div>
							<div *ngIf="show_addon_finance" class="col-xxs-4 visible-xxs visible-xs align-center col-or">
								<span *ngIf="p.vehicle.allowance !== null">or</span>
							</div>
							<div class="col-xxs-11 col-sm-7 col-cash text-hl" [ngClass]="{ 'col-xxs-30 col-sm-14': !show_addon_finance }">
								<span *ngIf="p.vehicle.allowance !== null">{{ -p.vehicle.allowance | money }}</span>
								<span *ngIf="p.vehicle.allowance === null"><small>Awaiting valuation</small></span>
							</div>
						</li>

						<!--  END PART EXCHANGE VEHICLE  -->

						<!--  FINANCE SETTLEMENT  -->

						<li *ngIf="p.vehicle.finance_settlement" class="row">
							<div class="col-xxs-30 col-sm-16 col-item-title">
								<div class="item-title">
									<div class="item-title-text">Finance Settlement Amount</div>
									<div class="item-subtitle-text">
										The total amount of payments you owe on your existing finance agreement for this vehicle.
									</div>
								</div>
							</div>
							<div *ngIf="show_addon_finance" class="col-xxs-15 col-sm-7 col-finance text-hl">
								<span>
									+ {{ pex_settlement_pm || 0 | money }}
									<small>P/M</small>
								</span>
							</div>
							<div *ngIf="show_addon_finance" class="col-xxs-4 visible-xxs visible-xs align-center col-or">
								<span>or</span>
							</div>
							<div class="col-xxs-11 col-sm-7 col-cash text-hl" [ngClass]="{ 'col-xxs-30 col-sm-14': !show_addon_finance }">
								{{ p.vehicle.finance_settlement || 0 | money }}
							</div>
						</li>

						<!--  END FINANCE SETTLEMENT  -->

						<!--  SUBTOTAL  -->

						<li class="row sub-total">
							<div class="col-xxs-30 col-sm-16 col-item-title">
								<div class="item-title">Sub Total:</div>
							</div>
							<div *ngIf="show_addon_finance" class="col-xxs-13 col-sm-7 col-finance">
								{{ (p.vehicle.allowance === null ? pex_settlement_pm : -pex_allowance_pm + pex_settlement_pm) | money }}
								<small>P/M</small>
							</div>
							<div *ngIf="show_addon_finance" class="col-xxs-4 visible-xxs visible-xs align-center col-or">
								<span>or</span>
							</div>
							<div class="col-xxs-13 col-sm-7 col-cash" [ngClass]="{ 'col-xxs-30 col-sm-14': !show_addon_finance }">
								{{
									(p.vehicle.allowance === null
										? p.vehicle.finance_settlement
										: -p.vehicle.allowance + p.vehicle.finance_settlement
									) | money
								}}
							</div>
						</li>

						<!--  END SUBTOTAL -->
					</ng-template>

					<!--  END PART EXCHANGES LOOP  -->
				</ul>

				<!--  END ITEMS  -->
			</div>
		</div>

		<!--  END PART EXCHANGE  -->

		<!-- GRAND TOTAL  -->

		<div class="customise-review-section grand-total">
			<div class="customise-review-section-inner">
				<ul class="items" [class.has-vat]="vehicle.add_vat">
					<!--  GRAND TOTAL NET  -->

					<li *ngIf="vehicle.add_vat" class="row sub-total">
						<div class="col-xxs-16 col-item-title">
							<div class="item-title">Sub Total (Ex. VAT):</div>
						</div>
						<div class="col-xxs-14 col-cash">
							{{ grand_total_net | money }}
						</div>
					</li>

					<!--  END GRAND TOTAL NET  -->

					<!--  GRAND TOTAL VAT  -->

					<li *ngIf="vehicle.add_vat" class="row sub-total">
						<div class="col-xxs-16 col-item-title">
							<div class="item-title">VAT Amount:</div>
						</div>
						<div class="col-xxs-14 col-cash">
							{{ grand_total_vat | money }}
						</div>
					</li>

					<!--  END GRAND TOTAL VAT  -->

					<!--  GRAND TOTAL GROSS  -->

					<li class="row">
						<div
							class="col-item-title"
							[ngClass]="{
								'col-xxs-16 col-sm-16': !show_addon_finance,
								'col-xxs-30 col-sm-16 ': show_addon_finance
							}"
						>
							<div class="item-title">Grand Total:</div>
						</div>
						<div *ngIf="show_addon_finance && selected_quote?.regular_payment" class="col-xxs-13 col-sm-7 col-finance">
							{{ selected_quote.regular_payment | money }}
							<small>P/M</small>
						</div>
						<div *ngIf="show_addon_finance" class="col-xxs-4 visible-xxs visible-xs align-center col-or">
							<span>or</span>
						</div>
						<div
							class="col-cash"
							[ngClass]="{
								'col-xxs-14 col-sm-14': !show_addon_finance,
								'col-xxs-13 col-sm-7 has-finance': show_addon_finance
							}"
						>
							{{ grand_total | money }}
						</div>
					</li>

					<!--  END GRAND TOTAL GROSS  -->
				</ul>
			</div>
		</div>

		<!-- END GRAND TOTAL  -->
	</div>

	<!-- END CONTAINER  -->

	<!--  TOTAL BAR  -->

	<cng-fixed-footer [loading]="loading"></cng-fixed-footer>

	<!--  END TOTAL BAR  -->

	<!--  STEP BAR  -->

	<cng-step-bar [current_step_key]="current_step_key" [show_next]="hasFollowingSteps()" (jump)="jumpTo($event)"></cng-step-bar>

	<!--  END STEP BAR  -->

	<!--  SCROLL FADES  -->

	<div class="scroll-fade top"></div>
	<div class="scroll-fade bottom"></div>

	<!-- END SCROLL FADES  -->
</div>
